import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue'),
    meta:{title:"登录"}
  },
  {
    path: '/getpassword',
    name: 'getpassword',
    component: () => import('../views/getpassword/index.vue'),
    meta:{title:"找回密码"}
  },
  {
    //首页
    path: '/',
    name: 'index',
    component: Index,
    redirect:"./home",
    children:[
      {
        path: 'home',
        name: 'home',
        component: () => import('../views/Home.vue'),
        meta:{title:"首页"}
      },
      {path: 'roleList',
        name: 'roleList',
        component: () => import('../views/roleList'),
        meta:{title:"角色列表"},
      },
      {path: 'users',
        name: 'users',
        component: () => import('../views/users'),
        meta:{title:"用户管理"},
      },
      {path: 'MenuList',
        name: 'MenuList',
        component: () => import('../views/MenuList'),
        meta:{title:"菜单管理"},
      },
      {
        path: 'masterDataManagement',
        name: 'masterDataManagement',
        component: () => import('../views/masterDataManagement'),
        meta:{title:"主数据管理"},
        children:[

          {
            path: 'productRelation',
            name: 'productRelation',
            component: () => import('../views/masterDataManagement/productRelation'),
            meta:{title:"产品主数据"},
            /*children:[
              {
                path: 'addSpecification',
                name: 'addSpecification',
                component: () => import('../views/masterDataManagement/productRelation/addSpecification/index.vue'),
                meta:{title:"添加规格"},
              }
            ]*/
          },

          {
            //商品分类
            path: 'ks',
            name: 'ks',
            component: () => import('../views/masterDataManagement/ks/index.vue'),
            meta:{title:"客商主数据"},
          },
          {
            path: 'company',
            name: 'company',
            component: () => import('../views/masterDataManagement/company/index.vue'),
            meta:{title:"公司主数据"},
          },
          {
            path: 'group',
            name: 'group',
            component: () => import('../views/masterDataManagement/group/index.vue'),
            meta:{title:"部门主数据"},
          },
          {
            path: 'person',
            name: 'person',
            component: () => import('../views/masterDataManagement/person/index.vue'),
            meta:{title:"人员主数据"},
          },
          {
            path: 'area',
            name: 'area',
            component: () => import('../views/masterDataManagement/area/index.vue'),
            meta:{title:"国家省份城市主数据"},
          },
          {
            path: 'unit',
            name: 'unit',
            component: () => import('../views/masterDataManagement/unit/index.vue'),
            meta:{title:"计量单位主数据"},
          },
          {
            path: 'currency',
            name: 'currency',
            component: () => import('../views/masterDataManagement/currency/index.vue'),
            meta:{title:"币种主数据"},
          },
        ]
      },
      {
        path: 'businessSystemImport',
        name: 'businessSystemImport',
        component: () => import('../views/businessSystemImport'),
        meta:{title:"业务系统导入"},
        children:[
          {
            //商品分类
            path: 'ks',
            name: 'ks',
            component: () => import('../views/businessSystemImport/ks/index.vue'),
            meta:{title:"客商"},
          },
          {
            path: 'company',
            name: 'company',
            component: () => import('../views/businessSystemImport/company/index.vue'),
            meta:{title:"公司"},
          },
          {
            path: 'group',
            name: 'group',
            component: () => import('../views/businessSystemImport/group/index.vue'),
            meta:{title:"部门"},
          },
          {
            path: 'person',
            name: 'person',
            component: () => import('../views/businessSystemImport/person/index.vue'),
            meta:{title:"人员"},
          },
          {
            path: 'area',
            name: 'area',
            component: () => import('../views/businessSystemImport/area/index.vue'),
            meta:{title:"国家省份城市"},
          },
          {
            path: 'unit',
            name: 'unit',
            component: () => import('../views/businessSystemImport/unit/index.vue'),
            meta:{title:"计量单位"},
          },
          {
            path: 'currency',
            name: 'currency',
            component: () => import('../views/businessSystemImport/currency/index.vue'),
            meta:{title:"币种"},
          },
          {
            path: 'productName',
            name: 'productName',
            component: () => import('../views/businessSystemImport/productName/index.vue'),
            meta:{title:"产品"},
          },
        ]
      }

    ]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
